import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  calenderIcon,
  clocksmall,
  proceesingblue,
  checkout,
  cancelled,
  noshow,
  readyforcheckout,
} from "../svgs";
import DateRangeSelector from "../../../daterangepicker/DateRangeSelector";
import dayjs from "dayjs";
import OrderHistoryModal from "../orderhistorymodal";
import api from "../../../api/api";
import { set } from "date-fns";
import { Backdrop, CircularProgress } from "@mui/material";
import utc from "dayjs/plugin/utc";
import { getPracticeId } from "../../../config/practice";

dayjs.extend(utc);

// Status Classes
const getStatusClasses = (status) => {
  switch (status) {
    case "Checked Out":
      return "bg-[#E8F4F2] text-[#1F6F63] border-[1px] border-[#CDE7E1]";
    case "Processing":
      return "bg-[#F0FDF4] text-[#1447E6] border-[1px] border-[#BEDBFF]";
    case "Cancelled":
      return "bg-[#F0FDF4] text-[#C10007] border-[1px] border-[#FFC9C9]";
    case "No Show":
      return "bg-[#FAF5FF] text-[#364153] border-[1px] border-[#E5E7EB]";
    case "Ready for Checkout":
      return "bg-[#F1F5F9] text-[#BB4D00] border-[1px] border-[#FEE685]";
    default:
      return "bg-gray-50 text-gray-600 border-[1px] border-gray-200";
  }
};

// Status Icons
const getStatusIcon = (status) => {
  switch (status) {
    case "Checked Out":
      return checkout;
    case "Processing":
      return proceesingblue;
    case "Cancelled":
      return cancelled;
    case "No Show":
      return noshow;
    case "Ready for Checkout":
      return readyforcheckout;
    default:
      return null;
  }
};

// "FOLLOW UP" / "Checked Out" both read as sentence case in the design.
const sentenceCase = (s) =>
  typeof s === "string" && s.length
    ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
    : s;

// Format Date
const formatDateTime = (datetimeStr) => {
  if (!datetimeStr) return "—";
  const date = new Date(datetimeStr);
  if (isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// Format Time
const formatTime = (datetimeStr) => {
  if (!datetimeStr) return "—";
  const date = new Date(datetimeStr);
  if (isNaN(date.getTime())) return "—";

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
};

const AppointmentHistory = ({ appointmenthistory = [],activeTab,data,isLoading = false }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
   const [orderhistory,setOrdersHistory]=useState(false)
   const practiseid = getPracticeId();
   const[Loading,setIsLoading]=useState(false)
   const [orderdetails,setOrderDetails]=useState({})
   const [apphistory,setAppHistory]=useState('')
   const [selectedAppointment,setSelectedAppointment]=useState(null)
  // Date range state
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  // Modal state
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCalendar]);

  // Handlers for DateRangeSelector
  const handleDateApply = () => {
    setCurrentPage(1); // reset to first page when filtering
    setShowCalendar(false);
  };

  const handleDateReset = () => {
    setSelectedDateRange({
      startDate: null,
      endDate: null,
      key: "selection",
    });
    setCurrentPage(1);
    setShowCalendar(false);
  };

  // Filtered appointments by date
  const filteredAppointments = useMemo(() => {
    if (!selectedDateRange.startDate || !selectedDateRange.endDate) {
      return appointmenthistory;
    }
    const start = new Date(selectedDateRange.startDate).setHours(0, 0, 0, 0);
    const end = new Date(selectedDateRange.endDate).setHours(23, 59, 59, 999);

    return appointmenthistory.filter((a) => {
      const apptDate = new Date(a.startdate).getTime();
      return apptDate >= start && apptDate <= end;
    });
  }, [appointmenthistory, selectedDateRange]);

  // Pagination logic
  const totalPages = Math.ceil(filteredAppointments.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentAppointments = filteredAppointments.slice(
    startIndex,
    startIndex + rowsPerPage
  );
const fetchordersdata=async({id,st,load})=>{
if(load){
    setIsLoading(true)
}
  try {
    const response=await api.post(`/v1/${practiseid}/orders/patient/${data?.patientid}/get-orders`,{
      "appointmentid":id,"orderdate":dayjs(st).format("YYYY-MM-DD")
    })

const isoDate = dayjs(st).format("YYYY-MM-DDTHH:mm:ss.SSS");

    const apphis=await api.post(`/v1/${practiseid}/pcard/${data?.patientid}/appHistory`,{
     "appointment_id":id,  apptdate:isoDate})
    if(response.status==200){
      setOrderDetails(response.data)
 
    }
    if(apphis.status==200){
      setAppHistory(apphis)
    }
  } catch (error) {
    console.log(error)
  }finally{
setIsLoading(false)
     setOrdersHistory(true)
  }
}
  return (
    <div className="rounded-[16px] border border-[#EDF1F7] bg-white p-[16px] shadow-sm sm:p-6">
      {/* Header */}
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-baseline gap-3">
          <h2 className="whitespace-nowrap text-[20px] font-inter font-semibold text-[#14213D]">
            Appointment history
          </h2>
          <span className="text-[15px] font-inter font-medium text-[#8A94A4]">
            {filteredAppointments.length} total
          </span>
        </div>

        <div className="flex items-center gap-2">
          {/* Date Range Toggle Button */}
          <div className="relative" ref={calendarRef}>
            <button
              onClick={() => setShowCalendar((prev) => !prev)}
              className="flex items-center gap-2 whitespace-nowrap rounded-[10px] border border-[#E3E8EF] bg-white px-4 py-2.5 text-[14px] font-inter font-semibold text-[#2c3357] shadow-sm hover:bg-[#F7F9FC]"
            >
              <span className="[&>svg]:h-4 [&>svg]:w-4">{calenderIcon}</span>
              {selectedDateRange.startDate && selectedDateRange.endDate
                ? `${dayjs(selectedDateRange.startDate).format("MM/DD/YYYY")} - ${dayjs(
                    selectedDateRange.endDate
                  ).format("MM/DD/YYYY")}`
                : "Date range"}
            </button>

            {/* Calendar Modal */}
            {showCalendar && (
              <div className="absolute right-0 mt-2 z-50 bg-white shadow-lg rounded">
                <DateRangeSelector
                  onSubmit={handleDateApply}
                  handlereset={handleDateReset}
                  selectedDateRange={selectedDateRange}
                  setSelectedDateRange={setSelectedDateRange}
                />
              </div>
            )}
          </div>
           {selectedDateRange.startDate && selectedDateRange.endDate && (
    <div className="flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-blue-50 text-blue-700 border border-blue-200">
      {dayjs(selectedDateRange.startDate).format("MM/DD/YYYY")} -{" "}
      {dayjs(selectedDateRange.endDate).format("MM/DD/YYYY")}
      <button
        onClick={handleDateReset}
        className="ml-1 text-blue-500 hover:text-blue-700"
      >
        ✕
      </button>
    </div>
  )}

        </div>
      </div>

      {/* Table */}
      <div className="overflow-hidden rounded-[14px] border border-[#EDF1F7]">
        {isLoading ? (
          <div className="p-4 text-center text-gray-500">Loading...</div>
        ) : filteredAppointments.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            No appointments found
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] text-left text-sm [&_td:first-child]:whitespace-nowrap">
              <thead className="bg-[#FAFBFD] font-inter text-[11px] uppercase tracking-[0.8px] text-[#9AA4B5]">
                <tr className="border-b border-[#EDF1F7]">
                  <th className="px-[20px] py-3.5 text-left font-bold">Date &amp; time</th>
                  <th className="px-[20px] py-3.5 text-left font-bold">Purpose</th>
                  <th className="px-[20px] py-3.5 text-left font-bold">Visit status</th>
                  <th className="px-[20px] py-3.5 text-right font-bold">Orders</th>
                </tr>
              </thead>
<tbody className="divide-y divide-[#EDF1F7]">
  {currentAppointments.map((a) => (
    <tr
      key={a.appointmentid ?? `${a.start_date}-${a.purpose}`}
      className="align-middle hover:bg-[#FAFBFD]"
    >
      {/* Date & Time */}
      <td className="px-[20px] py-4 align-middle">
        <div className="flex flex-col justify-start">
          <div className="font-inter text-[14px] font-bold text-[#14213D]">
            {a.start_date ? formatDateTime(a.start_date) : "—"}
          </div>
          <div className="mt-0.5 font-inter text-[13px] font-medium text-[#64748B]">
            {a.start_date ? formatTime(a.start_date) : "—"}
          </div>
        </div>
      </td>

      {/* Purpose */}
      <td className="px-[20px] py-4 align-middle">
        <span className="inline-block rounded-[14px] bg-[#F1F3F7] px-3 py-1.5 font-inter text-[13px] font-medium text-[#48526A]">
          {sentenceCase(a.purpose)}
        </span>
      </td>

      {/* Status */}
      <td className="px-[20px] py-4 align-middle">
        {a.visit_confirmation ? (
          <span
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-3 py-1.5 font-inter text-[13px] font-semibold ${getStatusClasses(
              a.visit_confirmation
            )}`}
          >
            <span
              aria-hidden="true"
              className="h-[7px] w-[7px] rounded-full bg-current"
            />
            {sentenceCase(a.visit_confirmation)}
          </span>
        ) : (
          ""
        )}
      </td>

      {/* Orders */}
      <td className="px-[20px] py-4 align-middle">
        <div className="flex justify-end">
        <button
     onClick={() =>{
      setSelectedAppointment(a)
  fetchordersdata({
    id: a.appointmentid,
    st: a.startdate,load:true // only date
  })}
}
        className="ml-auto flex items-center gap-2 rounded-[10px] border border-[#E3E8EF] bg-white px-3.5 py-2 font-inter text-[13px] font-semibold text-[#2c3357] hover:bg-[#F7F9FC]">
          Orders
          <span aria-hidden="true" className="text-[13px] leading-none">&#8964;</span>
        </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>

            </table>
            </div>

            {/* Pagination */}
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#EDF1F7] px-[20px] py-4 text-sm">
              <span className="font-inter text-[14px] text-[#64748B]">
                Showing{" "}
                {filteredAppointments.length === 0
                  ? 0
                  : (currentPage - 1) * rowsPerPage + 1}
                &ndash;
                {Math.min(currentPage * rowsPerPage, filteredAppointments.length)}{" "}
                of {filteredAppointments.length}
              </span>
              <div className="flex gap-2">
                <button
                  className="rounded-[10px] border border-[#E3E8EF] px-4 py-2 font-inter text-[14px] font-semibold text-[#2c3357] hover:bg-[#F7F9FC] disabled:opacity-40"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>
                <button
                  className="rounded-[10px] border border-[#E3E8EF] px-4 py-2 font-inter text-[14px] font-semibold text-[#2c3357] hover:bg-[#F7F9FC] disabled:opacity-40"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
         <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={Loading}
>
  <CircularProgress color="inherit" />
</Backdrop>
            {orderhistory?<OrderHistoryModal
            selectedAppointment={selectedAppointment}
            apphis={apphistory}
            data={data}
            orderdetails={orderdetails}
            isOpen={orderhistory} onClose={setOrdersHistory}/>:<></>}
    </div>
  );
};

export default AppointmentHistory;
